module.exports = __webpack_public_path__ + "img/activity.e0296fb8.svg";